App.RestaurantsRestaurantController = Em.Controller.extend
  notifier: Em.inject.service()
  env:      Em.inject.service('environment')
  session:  Em.inject.service()
  store:    Em.inject.service('store')
  yandexMapsService: Em.inject.service('yandexMaps')
  dadataService:     Em.inject.service('dadata')

  needs: [ 'restaurants' ]

  restaurantsBinding: 'controllers.restaurants.model'
  restaurantBinding:  'model'

  currentTab: 'commonTab'
  tables: []
  showDineIn: false

  isCommonTab:     Em.computed.equal('currentTab', 'commonTab')
  isDineInTab:  Em.computed.equal('currentTab', 'dineInTab')

  isSaving: false
  isRushModeEnabled: Em.computed.alias('restaurant.organization.features.restaurant_rush_mode')
  serviceChargeEnabled: Em.computed.alias('restaurant.organization.features.service_charge')
  closingReasons: Em.computed.alias('env.features.restaurantDisableReasons')
  restaurantDisableCommentEnabled: Em.computed.alias('env.features.restaurantDisableCommentEnabled')
  selectedClosingReason: null

  readonlyLng: Em.computed.oneWay('restaurant.longitude')
  readonlyLat: Em.computed.oneWay('restaurant.latitude')

  # Координаты для карты по умолчанию, Москва
  mapLat: Em.computed 'readonlyLat', ->
    (@get('readonlyLat') || 55.754057)
  mapLng: Em.computed 'readonlyLng', ->
    (@get('readonlyLng') || 37.622372)

  addressProvider: (->
    return 'google' if @get('restaurant.organization.features.use_google_in_board')
    'dadata'
  ).property('restaurant.organization')

  nestedRestaurants: Em.computed.alias('env.features.nestedRestaurants')

  validations: {}

  VALIDATABLE_FIELDS: [
    'parent_id'
  ]

  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join('. ')

    errors.clear()
    validations

  flattenedRestaurants: (->
    @get('restaurants').filter((r) => r.id != @get('restaurant').id)
  ).property('restaurants', 'restaurant')

  # Есть ли Dine-in
  updateDineIn: (->
    @set('tables', [])
    @set('showDineIn', false)
    @get('store').find('delivery_zone', restaurant_id: @get('restaurant.id')).then (delivery_zones) =>
      @set('showDineIn', delivery_zones.any((dz) => dz.get('isDineIn')))
    @get('store').find('table', restaurant_id: @get('restaurant.id')).then (tables) =>
      @set('tables', tables)
  ).observes('restaurant')

  forceDestroy: false

  lastClosingReasonSelected: (->
    return false unless @get('closingReasons')
    @get('closingReasons')[@get('closingReasons').length - 1] == @get('selectedClosingReason')
  ).property('selectedClosingReason','closingReasons')

  showClosedMessageField: (->
    return false unless @get('restaurantDisableCommentEnabled')
    return true unless @get('closingReasons')
    @get('lastClosingReasonSelected')
  ).property('closingReasons', 'lastClosingReasonSelected','restaurantDisableCommentEnabled')

  geocodeAddress: ->
    r = @get('restaurant')
    if r.get('initAddress')
      r.set('initAddress', false)
      return
    if @get('addressProvider') == 'dadata'
      @get('dadataService').getSuggestions(r.get('address'))
      .then (res) =>
        firstObject = res.suggestions[0]
        if firstObject
          r.set 'latitude', firstObject.lat
          r.set 'longitude', firstObject.lon
        
    if @get('addressProvider') == 'yandex'
      @get('yandexMapsService').retrieve()
      .then (ymaps) =>
        ymaps.geocode(r.get('address'))
        .then (res) =>
          firstObject = res.geoObjects.getIterator()?.getNext()
          kind = firstObject?.properties?._data?.metaDataProperty?.GeocoderMetaData?.kind
          if firstObject
            coords = firstObject.geometry.getCoordinates()
            r.set 'latitude', coords[0]
            r.set 'longitude', coords[1]
    else
      return if r.get('isDirty')
      r.save()
      .then =>
        r.geocode()
      .then =>
        r.reload()

  addressObserver: (->
    return if @get('restaurant.skipGeocode')
    Em.run.debounce @, @geocodeAddress, 1000
  ).observes('restaurant.address')

  restaurantObserver:(->
    @set('currentTab','commonTab')
  ).observes('restaurant')

  # Зум карты 12 если ресторан новый, 15 если уже есть маркер
  zoom: Em.computed 'model.isNew', ->
    if @get('model.isNew') then 12 else 15

  # Проверка лимита реаторанов при создании нового ресторан
  isExceededRestaurantLimit: Ember.computed(
    'restaurant.isNew'
    'session.currentBilling.tariff_restrictions.max_restaurants'
    'session.currentBilling.tariff_restrictions.max_restaurants_constraint'
    'restaurants.length'
    ->
      # Эта проверка должна работать с учетом значения is_running ресторана, пока убираем ее
      # @get('restaurant.isNew') and @get('session.currentBilling.tariff_restrictions.max_restaurants_constraint') and @get('restaurants.length') > @get('session.currentBilling.tariff_restrictions.max_restaurants')
      false
  )

  # Вычисляем окончание "заведений"
  limitRestaurants: Ember.computed(
    'session.currentBilling.tariff_restrictions.max_restaurants'
    ->
      limit = @get('session.currentBilling.tariff_restrictions.max_restaurants')

      switch
        # todo i18n
        when limit == 1 then "#{limit} заведение"
        when limit < 5 then "#{limit} заведения"
        else "#{limit} заведений"
  )

  # timezones: TIMEZONES
  timezones: (->
    TIMEZONES
    TIMEZONES.map (z)=>
      name = z
      # todo i18n
      name += ' (по-умолчанию)' if z == @get('restaurant.organization.timezone_own')
      {
        name,
        id: z
      }
  ).property('restaurant.organization.timezone_own','restaurant.timezone_own')

  hasDefaultTimezone: (->
    @get('restaurant.organization.timezone_own') == @get('restaurant.timezone_own') || @get('restaurant.timezone_own') == null
  ).property('restaurant.organization.timezone_own','restaurant.timezone_own')

  timezone: Em.computed [
    'restaurant.organization.timezone',
    'restaurant.organization.timezone_own',
    'restaurant.timezone_own',
    'hasDefaultTimezone'
  ]..., ->
    if @get('hasDefaultTimezone')
      @get('restaurant.organization.timezone_own')
    else
      @get('restaurant.timezone_own')

  timezone_with_default: (->
    # todo i18n
    return "default (#{@get('timezone')})" if @get('hasDefaultTimezone')
    @get('timezone')
  ).property('timezone')

  actions:
    addTable: ->
      table = @get('store').createRecord('table', {
        restaurant: @get('restaurant'),
        name: Em.I18n.t('restaurants.edit.dine_in.table.new_table_name', number: @get('tables.length')+1)
      })
      @get('tables').pushObject table

    saveTable: (table) ->
      table.save()

    deleteTable: (table) ->
      if confirm(Em.I18n.t('restaurants.edit.dine_in.table.delete_confirm'))
        table.destroyRecord()

    changeSelectedClosingReason: (reason) ->
      @set('selectedClosingReason', reason)
      unless @get('lastClosingReasonSelected')
        @set('restaurant.closed_message', reason)
      else
        @set('restaurant.closed_message', '')
      false
    changeTimezone: (timezone) ->
      @get('restaurant').set('timezone', timezone)
      timezone = null if @get('restaurant.organization.timezone_own') == timezone
      @get('restaurant').set('timezone_own', timezone)
      false
    markerMoved: (event) ->
      if event.length > 0

        point = event[0].target.getLatLng()
        restaurant = @get('restaurant')

        restaurant.set('latitude',  point.lat)
        restaurant.set('longitude', point.lng)
        
      false

    destroyRestaurant: ->
      restaurant = @get('restaurant')

      if confirm(@get('env').translate('restaurants.remove_confirm'))
        restaurant.nonRESTAction('DELETE', '', {force: @get('forceDestroy')}).then(=>
          @get('restaurants').removeObject(restaurant)
          @transitionToRoute('restaurants')
        )
        .catch(=>
          restaurant.rollback()

          errorMessage = @get('env').translate('notifications.restaurant_destroy_error.message_fallback')
          errorTitle   = @get('env').translate('notifications.restaurant_destroy_error.title')

          @get('notifier').pushNotification
            type: 'error'
            title:    errorTitle
            message:  errorMessage
            duration: 5000
        )

      false


    saveRestaurant: ->
      restaurant = @get('restaurant')

      valid = not [
        restaurant.get('name')
        restaurant.get('phone')
        restaurant.get('address')
      ].any(Em.isEmpty)

      return alert(@get('env').translate('restaurants.validate_name_phone_address')) unless valid

      @set('isSaving', true)
      restaurant.save()
      .then =>
        @get('restaurants').addObject(restaurant)
        @transitionToRoute('restaurants.restaurant', restaurant)
        restaurant.set('api_password', '')
        @get('notifier').pushNotification
          type: 'success'
          title:   @get('env').translate('notifications.restaurant_saved.title')
          message: @get('env').translate('notifications.restaurant_saved.message')
          duration: 3000

      .catch =>
        errorMessage = @get('env').translate('notifications.restaurant_error.message_fallback')
        errorTitle   = @get('env').translate('notifications.restaurant_error.title')

        errors = restaurant.get('errors')

        if errors.has('organization')
          errorTitle    = @get('env').translate('restaurants.tarif_restriction.title')
          errorMessage  = @get('env').translate('restaurants.tarif_restriction.message')

        if errors.get('error.0.message')
          errorTitle    = null
          errorMessage  = errors.get('error.0.message')

        @get('notifier').pushNotification
          type: 'error'
          title:    errorTitle
          message:  errorMessage
          duration: 10000
          handler:  => @transitionToRoute('settings.billing')
      .finally =>
        @set('validations', @extractValidations(restaurant, @VALIDATABLE_FIELDS))
        @set('isSaving', false)

    cancel: ->
      restaurant = @get('restaurant')

      if confirm(@get('env').translate('restaurants.cancel_confirm'))
        restaurant.rollback()
        @transitionToRoute('restaurants')
